/**
 * Moves focus to `element` when it is still in the document, not inside a hidden or inert subtree, and accepts
 * focus. Returns whether focus is on `element` afterwards.
 */
export function restoreFocus(element: Element | null | undefined, options?: FocusOptions): boolean {
  if (!(element instanceof HTMLElement) || !element.isConnected || element === document.body)
    return false;
  if (element.closest('[hidden], [inert]')) return false;
  element.focus(options);
  return document.activeElement === element;
}

/** Whether no element has focus, as after the focused element was removed from the document. */
export function focusIsLost(): boolean {
  const active = document.activeElement;
  return active === null || active === document.body || active === document.documentElement;
}
